import { render, staticRenderFns } from "./ActivationsClient.vue?vue&type=template&id=2d11f9a4"
import script from "./ActivationsClient.vue?vue&type=script&lang=js"
export * from "./ActivationsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports